// export default 'http://127.0.0.1:8000/api';
// export default 'http://18.117.72.50:8000/api';
// export default 'https://statecs-backend-master-2-2ychklxqwq-ue.a.run.app/api';
export default 'https://api.statecs.de/v1/api';
